// extracted by mini-css-extract-plugin
module.exports = {"avatar":"AvatarPopover_avatar__zk1hg","disabled":"AvatarPopover_disabled___fpMG"};